import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { reducer as toastr } from 'react-redux-toastr'

import reducers from '../redux'

const rootReducer = combineReducers({
  ...reducers,
  form,
  toastr,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/config/index.js